import { render, staticRenderFns } from "./real.vue?vue&type=template&id=bafdfea2&scoped=true"
import script from "./real.vue?vue&type=script&lang=js"
export * from "./real.vue?vue&type=script&lang=js"
import style0 from "./real.vue?vue&type=style&index=0&id=bafdfea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafdfea2",
  null
  
)

export default component.exports